import { Groups } from '@mui/icons-material';
import { guard } from '../RequirePermission';
import { UserGroupList } from './UserGroupList';
import { UserGroupShow } from './UserGroupShow';
import { UserGroupCreate } from './UserGroupCreate';
import { UserGroupEdit } from './UserGroupEdit';

export { UserGroupList } from './UserGroupList';
export { UserGroupShow } from './UserGroupShow';
export { UserGroupCreate } from './UserGroupCreate';
export { UserGroupEdit } from './UserGroupEdit';

export const userGroupsResource = {
  list: guard('user-groups:read:all', UserGroupList),
  show: guard('user-groups:read:all', UserGroupShow),
  create: guard('user-groups:write:all', UserGroupCreate),
  edit: guard('user-groups:write:all', UserGroupEdit),
  icon: Groups,
  recordRepresentation: 'name',
  meta: { permissions: ['user-groups:read:all', 'user-groups:write:all'] as const },
};
